module.exports = __webpack_public_path__ + "static/media/caring_hands.dfdb7893.jpeg";